import { Link } from 'react-router-dom';

const services = [
  {
    title: 'Baie coulissante',
    description: 'Déblocage, roulettes, galets, rail, réglage, crémone, remplacement de baie vitrée coulissante aluminium.',
    icon: 'ri-door-open-line',
    image: '/images/service-baie-coulissante.png',
    link: '/reparation-baie-coulissante-herault/',
    featured: true,
  },
  {
    title: 'Volet roulant',
    description: 'Panne moteur, lame cassée, enrouleur, tablier bloqué. Dépannage volets roulants électriques et manuels.',
    icon: 'ri-store-3-line',
    image: '/images/service-volet-roulant.webp',
    link: '/reparation-baie-coulissante-herault/',
    featured: false,
  },
  {
    title: 'Vitrage / Vitrier',
    description: 'Remplacement de vitre cassée, double vitrage, vitrage isolant sur baies, fenêtres et portes-fenêtres.',
    icon: 'ri-contrast-drop-line',
    image: '/images/service-vitrage.jpg',
    link: '/double-vitrage-baie-coulissante-herault/',
    featured: false,
  },
  {
    title: 'Store / BSO',
    description: 'Réparation de stores bannes et BSO, toile, bras, moteur. Intervention sur toutes marques de stores extérieurs.',
    icon: 'ri-sun-line',
    image: '/images/service-store-banne.jpg',
    link: '/reparation-baie-coulissante-herault/',
    featured: false,
  },
  {
    title: 'Fenêtre',
    description: 'Poignée cassée, gond, joint d\'étanchéité, vitrage, fermeture difficile. Fenêtres alu, PVC et bois.',
    icon: 'ri-window-line',
    image: '/images/service-fenetre.jpg',
    link: '/reparation-baie-coulissante-herault/',
    featured: false,
  },
];

export default function ServiceCards() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-3">
            Nos services de dépannage menuiserie
          </h2>
          <p className="text-secondary-500 font-body text-base md:text-lg max-w-xl mx-auto">
            De la baie coulissante au volet roulant, en passant par le vitrage, nous intervenons sur tous types de menuiseries dans l'Hérault.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <Link
              key={service.title}
              to={service.link}
              className={`group relative bg-white rounded-lg overflow-hidden transition-all duration-300 hover:translate-y-[-2px] border ${
                service.featured
                  ? 'border-accent-500/30 hover:border-accent-500/60'
                  : 'border-background-200 hover:border-background-300'
              }`}
            >
              {service.featured && (
                <span className="absolute top-3 right-3 z-10 bg-accent-500 text-white text-xs font-heading font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  Cœur d'activité
                </span>
              )}

              {/* Image du service */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                {/* Icône superposée en bas à gauche */}
                <span className={`absolute bottom-3 left-3 w-10 h-10 flex items-center justify-center rounded-lg ${
                  service.featured
                    ? 'bg-accent-500 text-white'
                    : 'bg-white/90 text-primary-500'
                }`}>
                  <i className={`${service.icon} text-lg`}></i>
                </span>
              </div>

              {/* Contenu texte */}
              <div className="p-5">
                <h3 className="font-heading font-semibold text-lg text-primary-500 mb-2">
                  {service.title}
                </h3>
                <p className="text-secondary-500 text-sm font-body leading-relaxed">
                  {service.description}
                </p>
                <span className="inline-flex items-center gap-1 mt-4 text-accent-500 font-label font-semibold text-sm group-hover:gap-2 transition-all duration-200">
                  En savoir plus
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}